import { useScreen, useGrid } from 'vue-screen';

// Default breakpoint values for test environment
const defaultBreakpoints = {
  xs: '0px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
  '3xl': '1920px',
};

export const screen = useScreen();

// Handle test environment where useCssVar might not be available or return undefined
export const grid = useGrid({
  xs: (typeof useCssVar !== 'undefined' ? useCssVar('--breakpoint-xs')?.value : null) || defaultBreakpoints.xs,
  sm: (typeof useCssVar !== 'undefined' ? useCssVar('--breakpoint-sm')?.value : null) || defaultBreakpoints.sm,
  md: (typeof useCssVar !== 'undefined' ? useCssVar('--breakpoint-md')?.value : null) || defaultBreakpoints.md,
  lg: (typeof useCssVar !== 'undefined' ? useCssVar('--breakpoint-lg')?.value : null) || defaultBreakpoints.lg,
  xl: (typeof useCssVar !== 'undefined' ? useCssVar('--breakpoint-xl')?.value : null) || defaultBreakpoints.xl,
  '2xl': (typeof useCssVar !== 'undefined' ? useCssVar('--breakpoint-2xl')?.value : null) || defaultBreakpoints['2xl'],
  '3xl': (typeof useCssVar !== 'undefined' ? useCssVar('--breakpoint-3xl')?.value : null) || defaultBreakpoints['3xl'],
});
